<template>
    <div>
        <div>
            <el-button type="primary" @click="show = true">新增渠道</el-button>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :row-key="row=>JSON.stringify(row)"
                    :data="iosChannelList.beanList"
                    height="100%">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="渠道名称" align="center" prop="channelName"/>
                <el-table-column label="渠道ID" align="center" prop="channelId"/>
                <el-table-column label="渠道商品编码" align="center" prop="channelProductionCode"/>
                <el-table-column label="备注" align="center" prop="remark"/>
                <el-table-column align="center" width="220">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain @click="showEdit(scope.row)">信息</el-button>
                        <el-button
                                size="mini"
                                type="success"
                                plain
                                @click="$emit('component-change',{name:'config',id:scope.row.id})">配置
                        </el-button>
                        <el-button size="mini" type="danger" plain @click="removeRow(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :page-size="20"
                :pager-count="5"
                :total="iosChannelList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>

        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>编辑</h3>
                <el-form
                        ref="form"
                        class="common-popup-table"
                        label-width="125px"
                        size="medium"
                        :model="form"
                        :rules="rules">
                    <el-form-item label="渠道名称：" prop="channelName">
                        <el-input placeholder="请输入" v-model="form.channelName"></el-input>
                    </el-form-item>
                    <el-form-item label="渠道ID：" prop="channelId">
                        <el-input placeholder="请输入" v-model="form.channelId"></el-input>
                    </el-form-item>
                    <el-form-item label="渠道商品编码：" prop="channelProductionCode">
                        <el-input placeholder="请输入" v-model="form.channelProductionCode"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remark">
                        <el-input placeholder="请输入" v-model="form.remark"></el-input>
                    </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('form')">取消</el-button>
                    <el-button size="small" type="primary" @click="submitForm('form')">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                show: false,
                loading: false,
                currentPage: 1,
                form: {
                    id: '',
                    channelName: '',
                    channelId: '',
                    channelProductionCode: '',
                    remark: '',
                },
                rules: {
                    channelName: [
                        {required: true, message: '请输入渠道名称', trigger: 'blur'}
                    ],
                    channelId: [
                        {required: true, message: '请输入渠道ID', trigger: 'blur'}
                    ],
                    channelProductionCode: [
                        {required: true, message: '请输入渠道商品编码', trigger: 'blur'}
                    ],
                }
            }
        },
        computed: {
            ...mapState('product', ['iosChannelList']),
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('product', ['getIosChannelList', 'addIosChannel', 'updateIosChannel', 'deleteIosChannel']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getIosChannelList({
                    page
                }).then(() => {
                    this.loading = false;
                    if (!this.iosChannelList.length && page !== 1) {
                        this.getList(page - 1);
                    }
                })
            },
            close(formName) {
                this.$refs[formName].resetFields();
                this.show = false;
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let {id, ...params} = this.form;
                        if (id) {
                            this.updateIosChannel(this.form).then(() => {
                                this.$message.success('修改成功');
                                this.close(formName);
                                this.getList(this.currentPage);
                            })
                        } else {
                            this.addIosChannel(params).then(() => {
                                this.$message.success('添加成功');
                                this.close(formName);
                                this.getList(this.currentPage);
                            })
                        }
                    }
                })
            },
            showEdit(row) {
                this.form = {
                    id: row.id,
                    channelName: row.channelName,
                    channelId: row.channelId,
                    channelProductionCode: row.channelProductionCode,
                    remark: row.remark,
                };
                this.show = true;
            },
            removeRow(row) {
                this.$confirm(`确认删除${row.channelName}渠道吗？`, '提示', {
                    type: 'info'
                }).then(() => {
                    this.deleteIosChannel(row.id).then(() => {
                        this.$message.success('删除成功');
                        this.getList(this.currentPage);
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>